import { Box, Heading, Text } from "src/components/UI";
import { BulletNumberedImageCard } from "./Fragments";

const DirectDebitStepsContent = () => {
  const stepsData = [
    {
      title: "Pilih menu “Bayar Otomatis”",
      description: "",
    },
    {
      title: "Aktifkan “Bayar Otomatis”",
      description: "",
    },
    {
      title: "Pilih Kontrak",
      description: "",
    },
    {
      title: "Persetujuan Penggunaan",
      description: "",
    },
    {
      title: "Pilih Bank untuk pembayaran otomatis",
      description: "",
    },
    {
      title: "Lengkapi data",
      description: (
        <Box
          as="ul"
          fontFamily="Roboto, sans-serif"
          fontSize={["14px", "12px"]}
          fontWeight="400"
          lineHeight={["20px", "16px"]}
          letterSpacing={["0.16px", "0.24px"]}
          textAlign="left"
          listStyle="disc"
          padding={["0 14px"]}
        >
          <li>
            <Text>16 digit nomer kartu Debit</Text>
          </li>
          <li>
            <Text>No Hp yang terdaftar di Bank</Text>
          </li>
          <li>
            <Text>Exp Date kartu Debit</Text>
          </li>
        </Box>
      ),
    },
    {
      title: "Masukan kode OTP yang dikirimkan pada nomor terdaftar di BANK",
      description: "",
    },
    {
      title: "Persetujuan pengaktifan “Bayar Otomatis”",
      description: "",
    },
  ];
  return (
    <Box gap={[null, "24px"]}>
      <Heading
        fontSize={["15px", "24px"]}
        fontWeight={["500", "700"]}
        lineHeight={["24px", "28px"]}
        letterSpacing={["0.16px", "-0.24px"]}
        textAlign={["left", "center"]}
        padding={["16px", "unset"]}
        color={["#404040", "#000000"]}
      >
        Cara Daftar Bayar Otomatis
      </Heading>
      <Box
        display={["flex", "grid"]}
        gridTemplateColumns={["unset", "repeat(4, minmax(0, 1fr))"]}
        gridTemplateRows={["unset", "458px 1fr"]}
        gap={["16px", "40px 16px"]}
      >
        {stepsData.map((data, index) => {
          const order = index + 1;
          const imageSrc = `/static/images/png/direct-debit/bayar-otomatis-step-${order}.png`;

          return (
            <BulletNumberedImageCard
              key={index}
              order={order}
              title={data.title}
              description={data.description}
              imageSrc={imageSrc}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default DirectDebitStepsContent;
